// extracted by mini-css-extract-plugin
export default {"main":"Auth_main__XbB83","wrapper":"Auth_wrapper__5xeA-","formWrapper":"Auth_formWrapper__3BrmF","title":"Auth_title__fEp7k"};